import { useCallback, useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * The event is fired when the request Self Exclusion is successful.
 * @memberOf Playtech.API.events
 * @event self-exclusion-success
 * @example Playtech.on('self-exclusion-success', () => { ... });
 */
export const SELF_EXCLUSION_SUCCESS = 'self-exclusion-success';

export const useOnSelfExclusion = (eventTarget) => {
    const handleEvent = useCallback((...args) => {
        const event = new CustomEvent(SELF_EXCLUSION_SUCCESS, { detail: args });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(SELF_EXCLUSION_SUCCESS, handleEvent);

        return () => {
            publicEventsAPIService.off(SELF_EXCLUSION_SUCCESS, handleEvent);
        };
    }, [handleEvent]);

    const legacySelfExclusionListener = useCallback((...args) => {
        publicEventsAPIService.trigger(SELF_EXCLUSION_SUCCESS, ...args);
    }, []);

    useEffect(() => {
        dispatcher.listen(SELF_EXCLUSION_SUCCESS, legacySelfExclusionListener);

        return () => {
            dispatcher.removeListener(SELF_EXCLUSION_SUCCESS, legacySelfExclusionListener);
        };
    }, [legacySelfExclusionListener]);
};
